import { defineComponent, h } from 'vue';
import { QInput } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

export default defineComponent({
    name: 'form-number',
    components: { QInput },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        sync(prop, value) {
            const v = parseFloat(value);
            this.cmodel[prop] = v;
        }
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        propertygrid: false,
    },
    render() {
        if (!this.Condition)
            return null;

        let desc;
        if (this.schema.description)
            desc = <i class="mdi mdi-information" title={this.schema.description} style={{ color: "var(--v-checkboxGrey-base)", fontSize: "small", marginLeft: "3px" }}></i>;

        const name = <span style={{ marginLeft: (this.child * 15) + "px" }}>{this.name}</span>;

        let input;
        if (this.readonly)
            input = <QInput type="number" outlined dense hide-bottom-space style={{ width: "100%" }} modelValue={this.cmodel[this.schemakey]} readonly />;
        else
            input = <QInput type="number" outlined dense hide-bottom-space style={{ width: "100%" }} modelValue={this.cmodel[this.schemakey]} onUpdate:modelValue={(value) => this.sync(this.schemakey, value)} />;

        return (
            <tr>
                <td style={{ width: "1px" }}>
                    {name} {desc}
                </td>
                <td class={{ "property-grid": this.propertygrid }} style={this.propertygrid ? { minWidth: 0 } : undefined}>
                    {input}
                </td>
            </tr>
        );
    }
});